import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home'; 
import ThankYou from './thank-you';

const App = () => {
  return (
    
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/thank-you.html" element={<ThankYou />} />
      </Routes>
    
  );
};

export default App;
